import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { Lookup } from '../../../../shared-components/lookup/lookup.model';
import { LookupService } from '../../../../shared-components/lookup/lookup.service';
import { FreeReducedMealAppPerson } from '../../models/free-reduced-meal-app-person.model';

@Component({
  selector: 'app-frma-add-person',
  templateUrl: './frma-add-person.component.html',
  styleUrls: ['./frma-add-person.component.css']
})
export class FrmaAddPersonComponent implements OnInit {

  person: FreeReducedMealAppPerson = new FreeReducedMealAppPerson();
  errors: ErrorList[] = [];
  suffixes: Lookup[] = [];
  title: string;
  selectedSuffix: Lookup;

  @ViewChild('form', { read: NgForm, static: true }) form: NgForm;
  @ViewChild('firstName', { read: ElementRef }) firstName: ElementRef;
  @ViewChild('lastName', { read: ElementRef }) lastName: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FrmaAddPersonComponent>,
    private lookupService: LookupService
  ) {
    if (data) {
      this.person.IsStudent = data.isStudent;
      this.title = data.title;
    }
   }

  ngOnInit(): void {
    this.getSuffixes();
  }

  getSuffixes() {
    this.lookupService.getSuffixLookup('').pipe(take(1)).subscribe(suffixes => {
      this.suffixes = suffixes;
    });
  }

  validate() {
    this.errors = [];
    Object.keys((<FormGroup>this.form.form).controls).forEach(control => {
      this.form.form.get(control).markAsTouched();
    });
    if (!this.person.FirstName) {
      this.errors.push({
        fieldName: 'First Name',
        fieldRef: this.firstName,
        errorMsg: 'is required.'
      });
    }
    if (!this.person.LastName) {
      this.errors.push({
        fieldName: 'Last Name',
        fieldRef: this.lastName,
        errorMsg: 'is required.'
      });
    }
  }

  saveClick() {
    this.validate();
    if (this.errors.length == 0) {
      this.dialogRef.close(this.person);
    }
  }

  cancelClick() {
    this.dialogRef.close();
  }

  suffixChange() {
    if (this.selectedSuffix && this.selectedSuffix.Id) {
      this.person.SuffixID = parseInt(this.selectedSuffix.Id, 10);
    }
  }

}
